import { memo } from "react";
import portrait from "../../../../assets/images/portrait.png";
import styles from "./Header.module.scss";

const NAME = "Max Starling";
const POSITION = "Senior Full Stack Engineer";
const POSITION_MOBILE = "Senior Engineer";

function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.portrait}>
        <img
          alt="portrait"
          draggable={false}
          className={styles.portrait__img}
          src={portrait}
        />
      </div>
      <p className={`${styles.name} ${styles.name__shadow}`} />
      <p className={styles.name} />
      <p className={`${styles.position} ${styles.position__shadow}`}/>
      <p className={styles.position}/>
      <style>{`
        .${styles.name}::after {
          content: "${NAME}";
        }
        .${styles.position}::after {
          content: "${POSITION}";
        }
        @media only screen and (max-width: 960px) {
          .${styles.position}::after {
            content: "${POSITION_MOBILE}";
          }
        }`}</style>
    </header>
  );
}

export default memo(Header);
